module.exports = __webpack_public_path__ + "media/images/flags/1x1/ita-4fea969eb6f23d5642a857734b649bba.svg";